<section class="section" id="projects">
  <div class="container">
    <div class="section-head">
      <p class="eyebrow">Projet phare</p>
      <h2>Un projet unique, pensé pour un usage réel</h2>
      <p class="section-sub">
        Mise en avant d’un produit concret, construit avec exigence et impact.
      </p>
    </div>

    <div class="projects-grid">
      @for (project of projects; track project.name) {
        <article class="project-card" appReveal>
          <div class="project-header">
            <div>
              <h3>{{ project.name }}</h3>
              <p class="tagline">{{ project.tagline }}</p>
            </div>
            <div class="project-meta">
              <span class="status">{{ project.status }}</span>
              <span class="period">{{ project.period }}</span>
            </div>
          </div>

          <p class="description">{{ project.description }}</p>
          <p class="role">{{ project.role }}</p>

          <div class="project-body">
            <div>
              <h4>Points forts</h4>
              <ul>
                @for (item of project.highlights; track item) {
                  <li>{{ item }}</li>
                }
              </ul>
            </div>
            <div>
              <h4>Stack</h4>
              <div class="stack">
                @for (tech of project.stack; track tech) {
                  <span>{{ tech }}</span>
                }
              </div>
            </div>
          </div>

          <div class="project-actions">
            <a class="btn primary" [href]="project.link" target="_blank" rel="noopener">
              Voir le projet
            </a>
          </div>
        </article>
      }
    </div>
  </div>
</section>
